export const defaultSite = null;
export const defaultQuote = null;
export const defaultPickUpDate = null;
export const defaultDropOffDate = null;
export const defaultDriverAge = '21';
export const defaultPickUpTime = '10:00';
export const defaultDropOffTime = '10:00';
